import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import type { TireEfficiencyFlagProps as TireEfficiencyFlagUiProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import { EfficiencyFlagOverlayDialog } from '@packages/shared/src/ui/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { TireEfficiencyFlag as TireEfficiencyFlagUi } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import { TireEfficiencyFlagFragmentFragmentDoc } from '@packages/gql/generated/shopping/TireEfficiencyFlagFragmentFragmentDoc';
import { useIntl } from 'react-intl';
import { useLayerTracking } from '../../Tracking/hooks/useLayerTracking/useLayerTracking';
import { getTireEfficiencyFlagType } from '../getTireEfficiencyFlagType/getTireEfficiencyFlagType';
import { tireEfficiencyFlagMessages } from './messages';

/* GraphQL */ `
  fragment TireEfficiencyFlagFragment on TireEfficiencyFlag {
    level
    type
  }
`;

export type TireEfficiencyFlagProps = {
  data: FragmentType<typeof TireEfficiencyFlagFragmentFragmentDoc>;
  link: string;
} & Pick<TireEfficiencyFlagUiProps, 'size'>;

export const TireEfficiencyFlag = ({ data, link, size }: TireEfficiencyFlagProps) => {
  const { level, type } = getFragmentData(TireEfficiencyFlagFragmentFragmentDoc, data);

  const { formatMessage } = useIntl();
  const { trackViewLayer } = useLayerTracking();

  const handleOnDialogOpen = () => {
    trackViewLayer(`EEK Label(tireEfficiencyFlag)`);
  };
  const efficiencyFlagType = getTireEfficiencyFlagType(type);

  if (efficiencyFlagType === null) {
    return null;
  }

  return (
    <EfficiencyFlagOverlayDialog
      overlay={{
        title:
          type in tireEfficiencyFlagMessages ? formatMessage(tireEfficiencyFlagMessages[type]) : '',
        imgUrl: link,
      }}
      onDialogOpen={handleOnDialogOpen}
    >
      <TireEfficiencyFlagUi text={level} type={efficiencyFlagType} size={size} />
    </EfficiencyFlagOverlayDialog>
  );
};
